/* RHÔME — galerie, variantes et panier de la page produit */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return v + ' ' + (fmt || 'dh');
  }

  function boot(root) {
    var stage = root.querySelector('[data-rh-stage]');
    var main = root.querySelector('[data-rh-main]');
    if (!stage || !main) return;

    /* galerie */
    root.querySelectorAll('[data-rh-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-rh-thumb]').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        main.style.opacity = 0;
        setTimeout(function () {
          main.src = b.getAttribute('data-src');
          main.style.opacity = 1;
        }, 140);
      });
    });
    stage.addEventListener('mouseenter', function () { stage.classList.add('is-zoom'); });
    stage.addEventListener('mouseleave', function () {
      stage.classList.remove('is-zoom');
      main.style.transformOrigin = 'center';
    });
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      main.style.transformOrigin =
        ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });

    /* pointures */
    var form = root.querySelector('[data-rh-form]');
    var vid = root.querySelector('[data-rh-vid]');
    var err = root.querySelector('[data-rh-sizeerr]');
    var dot = root.querySelector('[data-rh-dot]');
    var stockTxt = root.querySelector('[data-rh-stocktxt]');
    var priceEls = root.querySelectorAll('[data-rh-btnprice]');
    var chosen = null;

    root.querySelectorAll('[data-rh-size]:not(.is-out)').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-rh-size]').forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        chosen = b.getAttribute('data-rh-size');
        if (vid) vid.value = b.getAttribute('data-vid');
        if (err) err.classList.remove('is-on');
        var qty = parseInt(b.getAttribute('data-qty'), 10);
        var tracked = b.getAttribute('data-tracked') === 'true';
        if (dot) dot.className = 'rh-dot' + (tracked && qty > 0 && qty <= 3 ? ' is-low' : '');
        if (stockTxt) {
          stockTxt.textContent = (tracked && qty > 0 && qty <= 3)
            ? 'Plus que ' + qty + ' paires en pointure ' + chosen + '.'
            : 'En stock en pointure ' + chosen + ' — expédié sous 24h.';
        }
        var p = b.getAttribute('data-price');
        if (p) priceEls.forEach(function (el) { el.textContent = p; });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!chosen && root.querySelectorAll('[data-rh-size]').length > 0) {
          e.preventDefault();
          if (err) err.classList.add('is-on');
          var sizes = root.querySelector('[data-rh-sizes]');
          if (sizes) sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        e.preventDefault();
        var btn = form.querySelector('[data-rh-add]');
        var old = btn ? btn.innerHTML : '';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid.value), quantity: 1 }] })
        }).then(function (r) { return r.json(); }).then(function () {
          if (btn) {
            btn.innerHTML = 'Ajouté au panier ✓';
            setTimeout(function () { btn.innerHTML = old; }, 1500);
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
        });
      });
    }

    var sticky = root.querySelector('[data-rh-sticky]');
    var addSticky = root.querySelector('[data-rh-addsticky]');
    if (addSticky && form) {
      addSticky.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
    var addrow = root.querySelector('.rh-addrow');
    if (sticky && addrow) {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('is-on', addrow.getBoundingClientRect().bottom < 0);
      });
    }

    var wish = root.querySelector('[data-rh-wish]');
    if (wish) wish.addEventListener('click', function () { wish.classList.toggle('is-on'); });

    /* guide des pointures */
    var modal = root.querySelector('[data-rh-guide]');
    var open = root.querySelector('[data-rh-openguide]');
    function close() { if (modal) modal.classList.remove('is-on'); }
    if (open && modal) {
      open.addEventListener('click', function (e) { e.preventDefault(); modal.classList.add('is-on'); });
      modal.querySelectorAll('[data-rh-closeguide]').forEach(function (b) { b.addEventListener('click', close); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    }
  }

  /* ajout rapide des accessoires */
  function addons(scope) {
    scope.querySelectorAll('[data-rh-addon]').forEach(function (b) {
      b.addEventListener('click', function () {
        var old = b.textContent;
        b.disabled = true;
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-rh-addon')), quantity: 1 }] })
        }).then(function (r) { return r.json(); }).then(function () {
          b.textContent = 'Ajouté ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () { b.textContent = old; b.disabled = false; }, 1400);
        }).catch(function () { b.disabled = false; });
      });
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-rh-pdp]').forEach(boot);
    addons(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
